class ProductTimer extends HTMLElement {
  static observedAttributes = ["sale-date"];

  constructor() {
    super();

    this.clock = this.children[0];
    this.countdown = this.children[1];

    // Target elements for the countdown
    this.hoursElement = this.countdown.querySelector('#hours');
    this.minutesElement = this.countdown.querySelector('#minutes');
    this.secondsElement = this.countdown.querySelector('#seconds');
  }

  connectedCallback() {
    this.updateTimerWithSaleDateStr(this.getAttribute('sale-date'));
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "sale-date") {
      this.updateTimerWithSaleDateStr(newValue);
    }
  }

  updateTimerWithSaleDateStr(saleDateStr) {
    if (this.saleDateStr === saleDateStr) {
      return;
    }

    this.saleDateStr = saleDateStr;
    if (this.timer) {
      // Reset the timer first
      clearInterval(this.timer);
    }

    if (!saleDateStr) {
      this.updateTimerVisibility(false);
      return;
    }

    this.targetDates = this.calculateTargetDates(saleDateStr);
    if (this.targetDates.length == 0) {
      this.updateTimerVisibility(false);
      return
    }

    let shouldStartTimer = false;
    const nowUTC = new Date();
    for (let index = 0; index < this.targetDates.length; index++) {
      const targetDate = this.targetDates[index];
      const timeLeft = targetDate.getTime() - nowUTC.getTime();
      if (timeLeft > 0) {
        shouldStartTimer = true;
        break;
      }
    }  
    
    if (!shouldStartTimer) {
      // do nothing since all sale dates have passed.
      this.updateTimerVisibility(false);
      return;
    }

    // Update countdown every second
    this.timer = setInterval(this.updateEasternTimeCountdown.bind(this), 1000);

    // Initial update to show countdown immediately
    this.updateEasternTimeCountdown();
  }

  calculateTargetDates(startDateStr) {
    let startDate = new Date(startDateStr);
    if (!startDate) {
      return [];
    }

    let numberOfDays = Number(this.getAttribute('number-of-days'));
    if (numberOfDays == 0) {
      numberOfDays = 1;
    }

    const startYear = Number(startDate.getUTCFullYear());
    const startMonth = Number(startDate.getUTCMonth());
    const startDay = Number(startDate.getUTCDate());

    // Target date in UTC, like November 27th, 00:00 AM ET (ET is UTC-5)
    startDate = new Date(Date.UTC(startYear, startMonth, startDay, 5, 0, 0)); // 5:00 AM UTC (midnight ET)

    // Add one day to the start date to get the deadline of the date
    startDate.setDate(startDate.getDate() + 1);

    const newDates = [];
    for (let index = 0; index < numberOfDays; index++) {
      const newDate = new Date(startDate);
      newDate.setDate(newDate.getDate() + index);
      newDates.push(newDate);
    }

    return newDates;
  }

  updateEasternTimeCountdown() {
    // Fetch current time in UTC
    const nowUTC = new Date();
    let timeLeft = 0;
    for (let index = 0; index < this.targetDates.length; index++) {
      const targetDate = this.targetDates[index];
      const tempLeft = targetDate.getTime() - nowUTC.getTime();
      if (tempLeft > 0) {
        timeLeft = tempLeft;
        break;
      }
    }

    if (timeLeft == 0) {
      // all sale dates has passed, so we just hide the timer and clear the interval.
      if (this.timer) {
        clearInterval(this.timer);
      }
      
      this.updateTimerVisibility(false);
      return;
    }

    if (timeLeft >= 24 * 60 * 60 * 1000) {
      // the sale date is more than 1 days aways, so we don't show the timer for now
      this.updateTimerVisibility(false);
      return;
    }

    this.updateTimerVisibility(true);
    this.updateCountElements(timeLeft);
  }

  updateCountElements(timeLeft) {
    // Calculate remaining time
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Update elements with remaining time
    this.hoursElement.textContent = ("0" + hours).slice(-2);
    this.minutesElement.textContent = ("0" + minutes).slice(-2);
    this.secondsElement.textContent = ("0" + seconds).slice(-2);

    // turn the clock to red when there is only one hour left.
    this.clock.style.backgroundColor = hours >= 1 ? "#434343" : "red";
  }

  updateTimerVisibility(show) {
    const element = this.parentElement;
    if (show) {
      if (element.classList.contains("hidden")) {
        element.classList.remove("hidden");
      }
    } else {
      if (!element.classList.contains("hidden")) {
        element.classList.add("hidden");
      }
    }
  }
}

customElements.define("product-timer", ProductTimer)

class ProductTimerRange extends HTMLElement {
  static observedAttributes = ["sale-end-date"];

  constructor() {
    super();

    this.clock = this.children[0];
    this.countdown = this.children[1];

    // Target elements for the countdown
    this.hoursElement = this.countdown.querySelector('#hours');
    this.minutesElement = this.countdown.querySelector('#minutes');
    this.secondsElement = this.countdown.querySelector('#seconds');
  }

  connectedCallback() {
    this.updateTimerWithSaleEndDateStr(this.getAttribute('sale-end-date'));
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "sale-end-date") {
      this.updateTimerWithSaleEndDateStr(newValue);
    }
  }

  updateTimerWithSaleEndDateStr(saleEndDateStr) {
    if (this.saleEndDateStr === saleEndDateStr) {
      return;
    }

    this.saleEndDateStr = saleEndDateStr;
    if (this.timer) {
      // Reset the timer first
      clearInterval(this.timer);
    }

    if (!saleEndDateStr) {
      this.updateTimerVisibility(false);
      return;
    }

    this.saleStartDate = new Date(this.getAttribute('sale-start-date'));
    this.saleEndDate = new Date(saleEndDateStr);
    if (!this.saleStartDate || !this.saleEndDate) {
      this.updateTimerVisibility(false);
      return
    }

    let shouldStartTimer = false;
    const nowUTC = new Date();
    const timeLefeBeforeEnd = this.saleEndDate.getTime() - nowUTC.getTime();
    if (timeLefeBeforeEnd >= 0) {
      shouldStartTimer = true; // sale hasn't finished, so need the timer
    }
    
    if (!shouldStartTimer) {
      this.updateTimerVisibility(false);
      return;
    }

    // Update countdown every second
    this.timer = setInterval(this.updateEasternTimeCountdown.bind(this), 1000);

    // Initial update to show countdown immediately
    this.updateEasternTimeCountdown();
  }

  updateEasternTimeCountdown() {
    // Fetch current time in UTC
    const nowUTC = new Date();
    const timeLeftBeforeStart = this.saleStartDate.getTime() - nowUTC.getTime();
    const timeLeftBeforeEnd = this.saleEndDate.getTime() - nowUTC.getTime();
    if (timeLeftBeforeStart >= 0) {
      // sale hasn't started yet
      this.updateTimerVisibility(false);
      return;
    }

    if (timeLeftBeforeEnd <= 0) {
      // sale date has passed, so we just hide the timer and clear the interval.
      if (this.timer) {
        clearInterval(this.timer);
      }
      
      this.updateTimerVisibility(false);
      return;
    }

    this.updateTimerVisibility(true);
    this.updateCountElements(timeLeftBeforeEnd);
  }

  updateCountElements(timeLeft) {
    // Calculate remaining time
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Update elements with remaining time
    this.hoursElement.textContent = ("0" + hours).slice(-2);
    this.minutesElement.textContent = ("0" + minutes).slice(-2);
    this.secondsElement.textContent = ("0" + seconds).slice(-2);

    // turn the clock to red when there is only one hour left.
    this.clock.style.backgroundColor = hours >= 1 ? "#434343" : "red";
  }

  updateTimerVisibility(show) {
    const element = this.parentElement;
    if (show) {
      if (element.classList.contains("hidden")) {
        element.classList.remove("hidden");
      }
    } else {
      if (!element.classList.contains("hidden")) {
        element.classList.add("hidden");
      }
    }
  }
}

customElements.define("product-timer-range", ProductTimerRange)